import * as React from 'react';
import { H5, NodataSVG, NotimetableWrap, Oops } from './styles';
import nodataSVG from '../../assets/No data.gif';

export const NoData = ({ title, subtitle }: { title: string; subtitle?: string }): JSX.Element => (
  <NotimetableWrap>
    <Oops>Oops!!</Oops>
    <H5>{title}</H5>
    <p className="pb-4">{subtitle}</p>
    <NodataSVG src={nodataSVG} />
  </NotimetableWrap>
);
